;(function() {
    function FeaturesSlider($elem, options) {
        this.timeSlide = 4000;
        this.timerIntervalId = 0;
        this.autoplay = true;

        $.extend(this, options);

        this.init($elem);
    }

    FeaturesSlider.prototype.init = function($elem) {
        var featuresSlider = this;

        if (!$elem.length) {
            return false;
        }

        this.$sliderTabs = $elem.find('.features-item__tab');
        this.$sliderImages = $elem.find('.features-item__img');
        this.nextSlideEvent = this.nextSlideEvent || (this.isDesktop ? 'mouseenter' : 'click touchstart');

        if (this.isDesktop) {
            this.start();

            if (this.autoplay) {
                $elem.on('mouseleave', function() {
                    this.refresh();
                }.bind(this));
            }
        }

        this.$sliderTabs.on(this.nextSlideEvent, function() {
            var index = parseInt($(this).attr('data-rel'));

            if (featuresSlider.isDesktop && featuresSlider.autoplay) {
                featuresSlider.stop();
            }

            if ($(this).hasClass('active')) {
                return;
            }

            if (featuresSlider.widgetName === 'PlanWidget') {
                featuresSlider.$sliderImages.parent().toggleClass('feature-group-desktop__img-layers--inverted');
            }

            featuresSlider.$sliderTabs.removeClass('active');
            featuresSlider.$sliderImages.removeClass('is-visible');
            featuresSlider.$sliderTabs.filter('[data-rel=' + index + ']').addClass('active');
            featuresSlider.$sliderImages.filter('[data-rel=' + index + ']').addClass('is-visible');
        });
    };

    FeaturesSlider.prototype.start = function() {
        this.timerIntervalId = setInterval(function() {
            var currentIndex = this.$sliderTabs.filter('.active').attr('data-rel');
            var nextIndex = parseInt(currentIndex) + 1;

            var nextTab = this.$sliderTabs.filter('[data-rel=' + nextIndex + ']');
            var nextImg = this.$sliderImages.filter('[data-rel=' + nextIndex + ']');

            if (!nextTab.length || !nextImg.length) {
                nextTab = this.$sliderTabs.eq(0);
                nextImg = this.$sliderImages.eq(0);
            }

            if (this.widgetName === 'PlanWidget') {
                this.$sliderImages.parent().toggleClass('feature-group-desktop__img-layers--inverted');
            }

            this.$sliderTabs.removeClass('active');
            this.$sliderImages.removeClass('is-visible');

            nextTab.addClass('active');
            nextImg.addClass('is-visible');
        }.bind(this), this.timeSlide);
    };

    FeaturesSlider.prototype.stop = function() {
        clearInterval(this.timerIntervalId);
    };

    FeaturesSlider.prototype.refresh = function() {
        this.stop();
        this.start();
    };

    window.FeaturesSlider = FeaturesSlider;
})();



// WEBPACK FOOTER //
// ./assets/js/vendor/features-slider.js